import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toggleConfirmModal } from '../../redux/vendor/ui/uiActions';
import { VendorState } from '../../redux/vendor/rootReducer';

/**
 * The one confirmation the app asks before destroying something.
 *
 * Open state lives in Redux rather than in props, because the caller that
 * raises it (a row menu, a toolbar) is usually gone from the tree by the time
 * the answer comes back.
 */
export default function ConfirmDialog(props) {
    const [t] = useTranslation();

    const { isConfirmModalOpen } = useSelector((state: VendorState) => state.ui);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(toggleConfirmModal());
    };

    const handleAccept = () => {
        props.handleAccepted();
        dispatch(toggleConfirmModal());
    };

    return (
        <Dialog open={isConfirmModalOpen} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent className="sm:max-w-lg">
                <DialogHeader>
                    <DialogTitle>{props.title}</DialogTitle>
                    <DialogDescription>{props.description}</DialogDescription>
                </DialogHeader>

                <DialogFooter>
                    <Button variant="outline" onClick={handleClose}>
                        {t('MODALS.CONFIRM.CLOSE')}
                    </Button>
                    {/* Outlined, not filled: the way out should never be the loudest button. */}
                    <Button
                        variant="outline"
                        className="border-destructive/40 text-destructive hover:bg-destructive/5 hover:text-destructive"
                        onClick={handleAccept}
                    >
                        {t('MODALS.CONFIRM.VALIDATE')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
